const { Fragment, createElement } = require('react');
const { KeyboardAvoidingView, ScrollView } = require('react-native');

const NOOP_SUBSCRIPTION = { remove: () => {} };

module.exports = {
  KeyboardAvoidingView,
  KeyboardAwareScrollView: ScrollView,
  KeyboardEvents: { addListener: () => NOOP_SUBSCRIPTION },
  KeyboardProvider: ({ children }) => createElement(Fragment, null, children),
};
